module.exports = __webpack_public_path__ + "static/media/mtu.9d8333f2.png";